export default __webpack_public_path__ + "static/media/public_api_icon.ab8ce66b.svg";